document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("live-search-input");
  if (searchInput) {
    const searchResults = document.getElementById("live-search-results");
    let searchTimeout;

    if (typeof tdea_ajax === "undefined") {
      console.error("Variables AJAX no están disponibles");
      return;
    }

    async function performSearch(searchTerm) {
      if (searchTerm.length < 2) {
        searchResults.innerHTML = "";
        searchResults.classList.remove("isOpen");
        return;
      }

      try {
        const response = await fetch(
          `${tdea_ajax.ajax_url}?action=live_search&s=${encodeURIComponent(
            searchTerm
          )}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          displayResults(data.data);
        } else {
          throw new Error("Formato de respuesta inválido");
        }
      } catch (error) {
        console.error("Error en la búsqueda:", error);
        searchResults.innerHTML =
          '<div class="search-error">Error al cargar los resultados</div>';
        searchResults.classList.add("isOpen");
      }
    }

    function displayResults(results) {
      if (results.length === 0) {
        searchResults.innerHTML =
          '<div class="no-results">No se encontraron resultados</div>';
        searchResults.classList.add("isOpen");
        return;
      }

      let html = "<ul class='live-search-list'>";
      results.forEach((item) => {
        html += `
                  <li class="live-search-item">
                      <a href="${item.url}" class="live-search-link">
                          ${item.title}
                      </a>
                  </li>
              `;
      });
      html += "</ul>";

      searchResults.innerHTML = html;
      searchResults.classList.add("isOpen");
    }

    searchInput.addEventListener("input", function () {
      clearTimeout(searchTimeout);
      const searchTerm = this.value.trim();

      if (searchTerm) {
        searchTimeout = setTimeout(() => {
          performSearch(searchTerm);
        }, 300);
      } else {
        searchResults.innerHTML = "";
        searchResults.classList.remove("isOpen");
      }
    });

    document.addEventListener("click", function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        searchResults.classList.remove("isOpen");
      }
    });

    const searchForm = document.querySelector(".top-bar__search");
    searchForm.addEventListener("submit", function (e) {
      if (searchInput.value.trim().length === 0) {
        e.preventDefault();
      }
    });
  }
});
